<template>
  <on-click-outside :do="close">
    <div>
      <div class="input-group date">
        <input
          type="text"
          class="form-control"
          :value="displayValue"
          @input="onInputDate"
          v-bind="{
            placeholder: displayFormat || format,
            ...$attrs
          }"
          ref="inputMonthPicker"
          @focus="open"
          @keydown="validateKeyInput"
        />
        <div class="input-group-addon" @click="open">
          <i class="fa fa-calendar"></i>
        </div>
      </div>
      <div
        class="bootstrap-datetimepicker-widget dropdown-menu bottom date-picker-dropdown"
        ref="dropdown"
        v-show="isOpen"
      >
        <ul class="list-unstyled">
          <li class="collapse in">
            <month-picker @select-month="selectMonth" :date-prop="value" :format="format" />
          </li>
        </ul>
      </div>
    </div>
  </on-click-outside>
</template>

<script>
import { trim } from 'lodash'
import moment from 'moment'
import Popper from 'popper.js'
import OnClickOutside from '@/components/OnClickOutside.vue'
import MonthPicker from '@/components/DatePicker/MonthPicker'

export default {
  name: 'TsMonthPickerInput',
  inheritAttrs: false,
  components: { MonthPicker, OnClickOutside },
  props: {
    value: {
      type: String | Number
    },
    closeOnSelect: {
      type: Boolean
    },
    format: {
      type: String,
      default: 'MM'
    },
    displayFormat: String
  },
  data() {
    return {
      isOpen: false
    }
  },
  computed: {
    displayValue() {
      if (trim(this.value) === '' || this.value === null || this.value === undefined) return ''

      return moment()
        .month(isNaN(this.value) ? this.value : this.value - 1)
        .format(this.displayFormat || this.format)
    }
  },
  beforeDestroy() {
    this.popper !== undefined && this.popper.destroy()
  },
  methods: {
    open() {
      if (this.$attrs.disabled !== undefined && this.$attrs.disabled !== false) {
        return
      }

      if (this.isOpen) {
        return
      }

      this.isOpen = true
      this.$nextTick(() => {
        this.setupPopper()
      })
    },
    setupPopper() {
      if (this.popper === undefined) {
        this.popper = new Popper(this.$refs.inputMonthPicker, this.$refs.dropdown, {
          placement: 'bottom',
          positionFixed: true,
          modifiers: {
            offset: {
              enabled: true,
              fn: data => {
                data.offsets.popper.left = data.offsets.reference.left
                data.offsets.popper.right = data.offsets.reference.right

                return data
              },
              order: 840
            }
          }
        })
      } else {
        this.popper.scheduleUpdate()
      }
    },
    close() {
      if (!this.isOpen) {
        return
      }
      this.isOpen = false
    },
    selectMonth(month) {
      this.$emit('input', month)

      if (this.closeOnSelect) this.close()
    },
    validateKeyInput(e) {
      if (['Backspace', 'Delete'].includes(e.key) || e.shiftKey || e.ctrlKey || e.altKey) {
        this.$emit('input', '')
        return
      }

      e.preventDefault()
    },
    onInputDate(e) {
      this.$emit('input', e.target.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.date-picker-dropdown {
  top: 7px !important;
  z-index: 1000;
}
</style>
